module.exports = __webpack_public_path__ + "media/images/icons/icon-phone-alpha-0384115766ae47d361b9f20582e9b77c.svg";